// extracted by mini-css-extract-plugin
export var deleteModal = "_hk-0";